import { render, staticRenderFns } from "./PersonPodra.vue?vue&type=template&id=733fa852&"
import script from "./PersonPodra.vue?vue&type=script&lang=js&"
export * from "./PersonPodra.vue?vue&type=script&lang=js&"
import style0 from "./PersonPodra.vue?vue&type=style&index=0&id=733fa852&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports